<template>
  <v-card v-bind="$attrs" @click="goDetail(devInfo)">
    <v-list three-line subheader style="padding-bottom: 0">
      <v-list-item
        style="min-height: 54px; padding: 0 8px 0 11px; position: relative"
      >
        <v-list-item-avatar style="border-radius: 0">
          <DeviceIconImage :dev-info="devInfo" :size="40" />
        </v-list-item-avatar>
        <v-list-item-content style="padding: 0px">
          <v-list-item-title style="min-height: 1.6rem">
            <!-- <PriorityLabel :value="orderInfo.GZ_PRIORITY" /> -->
            <v-row no-gutters style="width: 100%">
              <v-col :cols="9">
                <span
                  style="
                    overflow: auto;
                    overflow-wrap: break-word;
                    white-space: normal;
                    width: 100%;
                    color: #616161;
                    font-size: 0.91rem;
                    display: inline-block;
                    padding-top: 0.33rem;
                  "
                >
                  {{ devInfo.DEV_TEXT }}
                </span>
              </v-col>
              <v-col
                :cols="3"
                style="
                  text-align: right;
                  padding-top: 0.101rem;
                  padding-right: 0.3rem;
                "
              >
                <span style="font-size: 0.78rem">
                  <DeviceStateText :dev-info="devInfo" :off-line="offLine" :show-off-line="false"/>
                  <i
                    class="fa fa-angle-right"
                    style="margin-left: 0.3rem; color: #9e9e9e"
                    aria-hidden="true"
                  ></i>
                </span>
              </v-col>
            </v-row>
          </v-list-item-title>
          <!-- <v-list-item-subtitle style="margin-top:0.2rem;" v-if="devInfo.PROD_TYPE === 'ping'">
              <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;color:#9e9e9e;">
                IP: {{devProp.ip}}
              </div>
            </v-list-item-subtitle>
            <v-list-item-subtitle style="margin-top:0.3rem;font-size:0.76rem;">
              <span v-if="devInfo.ACTION_TIME">
                <i class="fa fa-clock-o" aria-hidden="true" style="color:#9E9E9E;font-size:0.75rem;margin-left:0.05rem;" />
                <span style="padding-left:0.3rem;color:#9e9e9e;">{{$moment(devInfo.ACTION_TIME).from()}}</span>
              </span>
            </v-list-item-subtitle> -->
        </v-list-item-content>
        <span
          style="
            position: absolute;
            top: 0.2rem;
            left: 0.5em;
            color: #9e9e9e;
            font-size: 0.75rem;
          "
          >{{ idx }}</span
        >
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import DeviceStateText from './components/DeviceStateText';
import DeviceIconImage from './components/DeviceIconImage';
export default {
  components: {
    DeviceStateText,
    DeviceIconImage
  },
  props: {
    devInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    devProp: {
      type: Object,
      default: () => {
        return {};
      }
    },
    idx: {
      type: Number,
      default: 0
    },
    offLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {},
  methods: {
    goDetail(item) {
      var that = this;
      var propType = item.PROD_TYPE;
      if (propType === 'ping') {
        that.$router.goPage({
          path: '/PingDetail',
          query: { iot_id: item.IOT_ID }
        });
      } else if (propType === 'process') {
        that.$router.goPage({
          path: '/ProcessDetail',
          query: { iot_id: item.IOT_ID }
        });
      } else if (propType === 'gateway') {
        that.$router.goPage({
          path: '/GatewayDetail',
          query: { iot_id: item.IOT_ID }
        });
      } else if (propType === 'hik_nvr') {
        that.$router.goPage({
          path: '/HikNvrDetail',
          query: { iot_id: item.IOT_ID }
        });
      } else if (propType === 'hik_camera') {
        that.$router.goPage({
          path: '/HikCameraDetail',
          query: { iot_id: item.IOT_ID }
        });
      } else if (propType === 'http') {
        that.$router.goPage({
          path: '/HttpDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else if (propType === 'tcp') {
        that.$router.goPage({
          path: '/TcpDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else if (propType === 'iis_site') {
        that.$router.goPage({
          path: '/IISSiteDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else if (propType === 'stat_any') {
        that.$router.goPage({
          path: '/StatAnyDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else if (propType === 'stat_template') {
        that.$router.goPage({
          path: '/StatTemplateDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else if (propType === 'aishu_ab') {
        that.$router.goPage({
          path: '/BackupDetail',
          query: { iot_id: item.IOT_ID }
        });

      } else {
        // that.$toast('页面未完成');
        that.$router.goPage({
          path: '/DefaultDetail',
          query: { iot_id: item.IOT_ID }
        });
      }
    }
  }
};
</script>

<style scoped>
.s {
  position: relative;
}
</style>
